import { requestModuleCommand, resetModuleCommand } from 'owa-calendar-module-command';
import { orchestrator } from 'satcheljs';
import { subscribeCloseComposeFormOrchestrator } from '../orchestrators/closeComposeFormOrchestrator';
import {
    toggleEnable,
    clearPreviewOnComposeDismiss,
    updatePreviewColor,
} from 'owa-quick-compose-controller';
import {
    showItemDeleteModal,
    hideItemDeleteModal,
    showMeetingDndModal,
    hideMeetingDndModal,
} from 'owa-calendar-modal-actions';
import { openMobilityCompose, closeMobilityCompose } from 'owa-mobility-compose';
import {
    closeQuickComposeForm,
    showQuickCompose,
    closeFullComposeForm,
    onShowFullCompose,
    setCalendarId,
} from 'owa-calendar-compose-form-store';
import { showItemPeek, hideItemPeek } from 'owa-calendar-peek';
import { showItemContextMenu, hideItemContextMenu } from 'owa-calendar-surface-contextmenu-actions';
import { onHideReadingPane, onShowReadingPane } from 'owa-calendar-reading-pane-actions';

// TODO: VSO #89735 Audit boundary between surface and board
// Many of these should probably be converted to lazy orchestrators or split/grouped by applicable view type

/**
 * Should stay in sync with the following files (but not necessarily be 1:1 as not all command stitches are needed):
 * - `calendarBoardOpxCommandOrchestrators.ts`
 * - `calendarBoardOpxComposeOrchestrators.ts`
 */

// Subscribes to actions for updating module command
export function registerModuleStitches() {
    orchestrator(showItemPeek, function () {
        requestModuleCommand('Open_ItemPeek');
    });

    orchestrator(hideItemPeek, function () {
        resetModuleCommand('Open_ItemPeek');
    });
    orchestrator(showItemContextMenu, () => {
        requestModuleCommand('Open_ItemContextMenu');
    });
    orchestrator(hideItemContextMenu, () => {
        resetModuleCommand('Open_ItemContextMenu');
    });
    orchestrator(onShowReadingPane, () => requestModuleCommand('Open_ReadPanel'));
    orchestrator(onHideReadingPane, () => {
        resetModuleCommand('Open_ReadPanel');
    });

    orchestrator(showQuickCompose, () => requestModuleCommand('Open_QuickCompose'));
    orchestrator(showItemDeleteModal, () => requestModuleCommand('Open_ItemDeleteModal'));
    orchestrator(hideItemDeleteModal, () => resetModuleCommand('Open_ItemDeleteModal'));
    orchestrator(showMeetingDndModal, () => requestModuleCommand('Open_MeetingDndModal'));
    orchestrator(hideMeetingDndModal, () => resetModuleCommand('Open_MeetingDndModal'));
    orchestrator(closeQuickComposeForm, () => resetModuleCommand('Open_QuickCompose'));

    orchestrator(onShowFullCompose, () => requestModuleCommand('Open_FullComposeForm'));
    orchestrator(openMobilityCompose, () => requestModuleCommand('Open_MobilityCompose'));
    orchestrator(closeMobilityCompose, () => resetModuleCommand('Open_MobilityCompose'));
    orchestrator(closeFullComposeForm, () => resetModuleCommand('Open_FullComposeForm'));
    subscribeCloseComposeFormOrchestrator();
    registerQuickComposeStiches();
}

// TODO: VSO #89735 Audit boundary between surface and board
// compose flow needs to be refactored to no longer rely on pseudo-stitches
export function registerQuickComposeStiches() {
    // subscribe for closeQuickComposeForm action clear preview item on quick compose dismiss
    orchestrator(closeQuickComposeForm, clearPreviewOnComposeDismiss);

    // subscribe for closeFullComposeForm action clear preview item on full compose dismiss
    orchestrator(closeFullComposeForm, clearPreviewOnComposeDismiss);

    // subscribe for hideItemPeek to disable quickAdd on item's peek dismiss
    orchestrator(hideItemPeek, toggleEnable);

    // subscribe for hideItemContextMenu to disable quickAdd on item's context menu dismiss
    orchestrator(hideItemContextMenu, toggleEnable);

    // subscribe for setCalendarId action to update the preview item color
    orchestrator(setCalendarId, actionMessage => updatePreviewColor(actionMessage.calendarId));
}
